import React, { FC, useEffect, useState } from 'react';
import clsx from 'clsx';
import axios from 'axios';
import { getIconByExtension, getTypeFile } from 'utils';

interface FilePreviewProps {
  title: string;
  url: string;
  name: string;
}

const FilePreview: FC<FilePreviewProps> = ({ title, url, name }) => {
  const [previewUrl, setPreviewUrl] = useState<string>();
  const extension = url.split('.').pop() || '';
  const isImage = getTypeFile(extension) === 'image';
  const isSvg = extension === 'svg';

  useEffect(() => {
    if (!url || !isImage) return;

    if (isSvg) {
      void extractSvgUrl(url).then(setPreviewUrl);
    } else {
      setPreviewUrl(url);
    }
  }, [isImage, isSvg, url]);

  const onClick = () => {
    if (!url) return;
    downloadFile(url, `${name}-${title}.${extension}`);
  };

  return (
    <button
      className="button-clear file preview"
      onClick={e => {
        e.stopPropagation();
        onClick();
      }}>
      {isImage && previewUrl ? (
        <img src={previewUrl} alt="file uploaded" className={clsx('inline-image', { svg: isSvg })} />
      ) : (
        <>
          <img src={getIconByExtension(extension)} alt={extension} />
          <span className="size-xxxs">{`Download ${extension}`}</span>
        </>
      )}
    </button>
  );
};

const extractSvgUrl = async (url: string): Promise<string | undefined> => {
  try {
    const res = await fetch(url);
    const svgText = await res.text();
    const blob = new Blob([svgText], { type: 'image/svg+xml' });
    return URL.createObjectURL(blob);
  } catch {
    return undefined;
  }
};

const downloadFile = (url: string, fileName: string) => {
  void axios
    .get(url, {
      headers: {
        'Content-Type': 'application/octet-stream',
      },
      responseType: 'blob',
    })
    .then(response => {
      const aLink = document.createElement('a');
      const blobUrl = window.URL.createObjectURL(response.data as Blob);
      aLink.href = blobUrl;
      aLink.download = fileName;
      aLink.click();
    });
};

export default FilePreview;
